import React, { useState } from 'react';
import { Box } from '@mui/material';
import SingleActivityInput from './SingleActivityInput';
import * as Reorder from '../../../../components/dnd/Reorder';
import { IClient, IExpertBrand } from './constants';
import SingleActivityEntry from './SingleActivityEntry';

interface Props {
  brandList: Array<IExpertBrand>;
  clients: Array<IClient>;
  updateClients: (clients: Array<IClient>) => void;
}

export default function BrandActivities({ clients, updateClients, ...rest }: Props) {
  const [editableIndex, setEditableIndex] = useState(-1);

  const addActivity = (activity: IClient) => {
    updateClients([activity, ...clients]);
    setEditableIndex(-1);
  };

  const updateActivity = (activity: IClient, index: number) => {
    const tempList = [...clients];
    tempList[index] = activity;
    updateClients([...tempList]);
    setEditableIndex(-1);
  };

  const removeActivity = (index: number) => {
    const tempList = [...clients];
    tempList.splice(index, 1);
    updateClients([...tempList]);
  };

  return (
    <Box className="flex flex-col gap-2 w-full">
      <SingleActivityInput {...rest} onChange={addActivity} />

      <Reorder.Root options={clients} onUpdateOrder={updateClients}>
        {clients.map((item: IClient, index) => {
          if (editableIndex === index) {
            return (
              <SingleActivityInput
                {...rest}
                key={`interest-${item}-${index}`}
                activity={item}
                onChange={(activity: IClient) =>
                  updateActivity(activity, index)
                }
              />
            );
          }

          return (
            <SingleActivityEntry
              index={index}
              activity={item}
              onEdit={setEditableIndex}
              onRemove={removeActivity}
            />
          );
        })}
      </Reorder.Root>
    </Box>
  );
}
